import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FuelEuComponent } from './fuel-eu.component';

const routes: Routes = [
  {
    path: '',
    component: FuelEuComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FuelEuRoutingModule {}
